<template>
  <div id="app">
    <header class="header" :class="[isIndex ? 'header-index' : '']">
      <div class="ctn">
        <div class="name">
          <p>中国石油类高校</p>
          <p>知识产权信息公共服务平台</p>
          <div class="subname">
            Intellectual Property Information Service Platform for China Petroleum Industry-specific Universities
          </div>
        </div>
        <div class="user">
          <router-link to="/login" v-if="!isLogin()">
            <div class="btn">登陆</div>
          </router-link>
          <div class="btn" v-else @click="logout">退出登陆</div>
          <!-- <div class="btn" v-if="isLogin()" @click="logout">退出登陆</div> -->
        </div>
      </div>
      <nav class="nav">
        <ul>
          <router-link to="/">
            <li class="active">首页</li>
          </router-link>
          <router-link to="/servicelist">
            <li>服务清单</li>
          </router-link>
          <router-link to="/news">
            <li>政策新闻</li>
          </router-link>
          <router-link to="/patent">
            <li class="patent">专利查询</li>
          </router-link>
          <router-link to="/chartsdetail">
            <li>统计分析</li>
          </router-link>
          <router-link to="/school">
            <li>高校简介</li>
          </router-link>
          <router-link to="#">
            <li>分类发明人</li>
          </router-link>
          <router-link to="/technical_demander">
            <li>技术需求方</li>
          </router-link>
          <!-- <router-link to="#">
            <li>专利代理</li>
          </router-link> -->
          <router-link to="#">
            <li>其他</li>
          </router-link>
        </ul>
      </nav>
    </header>

    <a-back-top />

    <div class="main">
      <router-view />
    </div>
    <footer class="footer">
      <div class="ctn">
        <p>数据来源：国家知识产权局</p>
        <div class="inline">
          <p>主办单位：中国石油大学（华东）图书馆 | 中国石油大学(华东)知识产权信息服务中心</p>
          <p>地址：青岛市黄岛区长江西路66号</p>
          <p>咨询电话：0532-86983409 ｜ 86983423</p>
        </div>
        <p>技术支持：山东和学教育科技有限公司</p>
        <p>ICP备案编号：</p>
      </div>
    </footer>
  </div>
</template>

<script>
import { isLogin } from '@/utils/util'
import store from '@/store'
export default {
  data() {
    return {
      isLogin,
      isIndex: true
    }
  },
  methods: {
    logout() {
      console.log('退出登陆')
      store.dispatch('Logout').then(() => {
        this.$router.push({ path: '/login' })
      })
    }
  },
  mounted() {
    this.$route.path == '/' ? this.isIndex = true : this.isIndex = false;
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        console.log('route变了', val)
        if (val.path == '/') {
          // 首页
          this.isIndex = true;
        } else {
          this.isIndex = false;
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/style/style";
@import "@/style/init";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;

  display: flex;
  flex-direction: column;
  justify-content: space-around;
  min-height: 100vh;
  min-width: 1200px;
}

// header {
//   height: 100px;
//   background-image: url('@/assets/img/headerbg.png');
//   background-position: 50% 50%;

//   .name {
//     width: 1200px;
//     margin: auto;
//     height: 100px;
//     display: flex;
//     align-items: center;
//     justify-content: space-between;

//     .btn {
//       border: 1px solid #eee;
//       background-color: #fff;
//       padding: 5px 10px;
//       cursor: pointer;
//       color: #000;
//     }
//   }
// }
.header,
.header-index {
  background-image: url('@/assets/img/bg-header.png');
  background-size: 102% 115%;
  background-repeat: no-repeat;
  height: 250px;
  background-position: -15px -15px;
  // display: flex;
  // align-items: center;
  position: relative;
  text-shadow: 2px 2px 2px rgba(0, 66, 136, 0.63);
  // -webkit-text-stroke: 1px #004288;
  // text-stroke: 1px #004288;

  .ctn {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 1200px;
    margin: 30px auto 0;

    .name {
      font-size: 30px;
      font-weight: bold;
      color: #003B7B;
      letter-spacing: 1px;
      text-shadow: 5px 5px 5px #fff, -3px -4px 5px #fff;

      p {
        margin: 0;
      }

      .subname {
        font-size: 14px;
        color: #003B7B;
        letter-spacing: 1px;
        text-shadow: 5px 5px 5px #fff, -3px -4px 5px #fff;
      }
    }

    .user {
      // height: 45px;
      background: #F1F2F3;
      // background: red;
      border-radius: 23px;
      padding: 2px 10px;

      .btn {
        color: #003B7B;
      }
    }
  }

  .nav {
    width: 1200px;
    margin: 40px auto 0;
    font-size: 20px;

    ul {
      display: flex;
      font-weight: bold;
      justify-content: space-between;

      a {
        color: #003A80;
        width: 100px;
      }
    }
  }
}

.header-index {
  background-image: url('@/assets/img/bg-header-index.png');
  height: 500px;

  .nav ul a {
    color: #fff;
  }
}

// .nav {
//   height: 60px;
//   background-color: $cbase;

//   ul {
//     display: flex;
//     font-size: $size-h2;
//     width: 1200px;
//     margin: auto;

//     li {
//       width: 200px;
//       text-align: center;
//       line-height: 60px;
//       color: #fff;
//       cursor: pointer;
//       z-index: 999;

//       &:hover {
//         background-color: $cbase2;
//         border-radius: 40px;
//       }
//     }

//     .patent {
//       height: 60px;
//       position: relative;

//       &:hover .patent-child {
//         height: 60px;
//         opacity: 1;
//       }

//       .patent-child {
//         position: absolute;
//         height: 0;
//         overflow: hidden;
//         color: #000;
//         background-color: #fff;
//         width: 200px;
//         border-radius: 40px;
//         opacity: 0;
//         transition: height .2s, opacity .5s;
//       }

//     }

//     .active {
//       background-color: $cbase2;
//       border-radius: 40px;
//     }
//   }
// }

.main {
  flex: 1 1 auto;
  height: 100%;
  background-image: url('@/assets/img/bgstart.png');
  background-position: 100%;
  background-size: cover;
  background-repeat: no-repeat;
}

.footer {
  // height: 210px;
  background: #F2F4FA;

  .ctn {
    color: #333333;
    width: 1200px;
    margin: auto;
    padding-top: 30px;

    p {
      padding: 5px 0;
    }

    .inline {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
